import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";

const ManagePackages = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: 1,
      name: "Platinum",
      price: "€144.99",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: "Gold",
      price: "€94.99",
      createdDate: "01-Sept-2025",
      status: true,
      bestValue: true,
    },
    {
      id: 3,
      name: "Silver",
      price: "€59.99",
      createdDate: "01-Sept-2025",
      status: false,
    },
    {
      id: 4,
      name: "Bronze",
      price: "€42.99",
      createdDate: "01-Sept-2025",
      status: true,
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Packages</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Packages
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Packages..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-packages/add")}
            >
              <AddIcon /> Add Package
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Package Name</TableCell>
                <TableCell>Price / Month</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <div className="user_block">
                      <p>
                        <b>{row.name}</b>
                      </p>
                      {row.bestValue && (
                        <div className="status_btn c_dark_primary">Best value</div>
                      )}
                    </div>
                  </TableCell>

                  <TableCell>{row.price}</TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>

                  <TableCell>{row.createdDate}</TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate("/manage-packages/detail")}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="View"
                        />
                      </IconButton>

                      <IconButton onClick={() => navigate("/manage-packages/edit")}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>

                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManagePackages;
